import React, {useState, useEffect, useRef} from 'react';
import * as AuthService from '../../services/auth';
import {ContentHeader} from '@components';
import {logoutUser} from '@store/reducers/auth';
import Card from 'react-bootstrap/Card';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
export default function Calendar() {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const calendarRef = useRef<any>(null);
  const [cars, setCars] = useState<any[]>([
    {
      id: 'CR_C1',
      title: 'C1 : รถยืม',
      backgroundColor: '#f39c12',
      visible: true
    },
    {
      id: 'CR_C2',
      title: 'C2 [เก๋ง EV] [ยืมรถ/คนขับ]',
      backgroundColor: '#00c0ef',
      visible: true
    }
  ]);
  const [events, setEvents] = useState<any[]>([
    {
      cid: 'CR_C1',
      title: 'รถ C1',
      date: '2023-12-01',
      backgroundColor: '#f39c12',
      borderColor: '#f39c12',
      textColor: '#000000'
    },
    {
      cid: 'CR_C2',
      title: 'รถ C2',
      start: '2023-12-01',
      end: '2023-12-05',
      backgroundColor: '#00c0ef',
      borderColor: '#00c0ef',
      textColor: '#000000'
    }
  ]);

  useEffect(() => {
    downloadCarWs();
  }, []);

  const downloadCarWs = async () => {
    try {
      let cars = await AuthService.downloadCars();
      console.log(cars);
      if (cars.error) throw 'timeout';
      if (Object.keys(cars).length !== 0) {
        // cars = cars.filter((e: any)=>(e.));
        setCars(cars.cars);
        setEvents(cars.carsCalendar);
      } else {
        setCars([]);
        setEvents([]);
      }
    } catch (error: any) {
      // dispatch(logoutUser());
      // window.location.href = '/login';
    }
  };

  const handleDateClick = (dateClickInfo: any) => {
    calendarRef.current.getApi().changeView('timeGridDay', dateClickInfo.date);
  };

  return (
    <div>
      <ContentHeader title="Calendar" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 col-12">
              <Card className="card-primary">
                <Card.Body>
                  <div id="external-events">
                    {cars.map((e) => (
                      <div
                        className="external-event"
                        style={{backgroundColor: e.backgroundColor}}
                      >
                        <label className="font-weight-normal small">
                          <input
                            type={'checkbox'}
                            checked={e.visible}
                            onChange={(e) => {
                              let _cars = cars.map((e1) => {
                                return e1.id !== e.currentTarget.id
                                  ? e1
                                  : {...e1, visible: e.currentTarget.checked};
                              });
                              setCars(_cars);
                            }}
                            id={e.id}
                            className="mr-2 mt-2"
                          />
                          {e.title}
                        </label>
                      </div>
                    ))}
                  </div>
                </Card.Body>
              </Card>
              <Card className="card-danger">
                <Card.Header>หมายเหตุและคำแนะนำ</Card.Header>
                <Card.Body>
                  🚩 งานวิ่งรถ EV อนุญาตให้เดินทางระหว่างจังหวัดกรุงเทพฯ(ปริมณฑล), ฉะเชิงเทรา และปราจีนบุรีเท่านั้น
                  งานเดินทางนอกพื้นที่จะถูกปฏิเสธ
                  <br /><br />
                  🚩 พนักงานจะต้องสำรองจ่ายค่าจอดรถ, ค่าผ่านทางพิเศษ, ค่าเชื้อเพลิง EV ก่อน, และทาง CR/GA 
                  จะทำจ่ายคืนพนักงานผู้จองภายหลัง
                  <br /><br />
                  🚩 งานวิ่งรถ EV 1 งานจะมีระยะเวลาปลอดภัย 1
                  ชั่วโมงก่อนเริ่มงานและหลังจบงาน เพื่อวัตถุประสงค์ให้ จนท.
                  ตรวจสอบสภาพรถหรือป้องกันการส่งรถล่าช้า
                  <br /><br />
                  🚩 ตัวอย่าง
                  <br />
                  👉 งานวิ่งที่คืนรถเวลา 12.00น.,
                  จะสามารถจองใช้ได้อีกครั้งในเวลา 13.00น. หรือ
                  <br />
                  👉 หากมีงานวิ่งที่เริ่มเวลา 13.00น. อยู่แล้ว,
                  คุณจะสามารถจองใช้ได้ก็ต่อเมื่องานของคุณส่งคืนรถก่อน 12.00น. เท่านั้น
                </Card.Body>
              </Card>
              <Card className="card-danger">
                <Card.Body>
                  🚗 ประกาศ: ข้อปฏิบัติการยืมรถยนต์ไฟฟ้า (EV) บริษัท (กรณีพนักงานยืมรถขับเอง)<br /><br />
                  📍 สถานที่รับ-คืนกุญแจ<br />
                  อาคารผู้บริหาร aA5 (Project PM3)<br /><br />
                  ⏰ เวลาทำการ และ รายชื่อผู้ติดต่อ<br />
                  วันจันทร์ - วันศุกร์ | เวลา 08.10 - 18.00 น.<br />
                  คุณจิราภรณ์ โทร. 5-4616<br />
                  คุณนิภาพร โทร. 5-8713<br />
                  หมายเหตุสำคัญ: ในขณะรับรถจะมีเจ้าหน้าที่แจ้งรายละเอียดเพิ่มเติม และทำการ Video ตรวจเช็คสภาพรถ ก่อนเริ่มใช้งานทุกครั้ง
                  <br /><br />
                  💡 กรณีบริการนอกเวลาทำการ (After Hours)<br />
                  การรับกุญแจล่วงหน้า: หากต้องใช้รถก่อนเวลาทำการ สามารถมารับกุญแจล่วงหน้าได้ 1 วัน (กรุณาสอบถามเจ้าหน้าที่ดูแล: คุณสุรีรัตน์ โทร. 5-2855)<br />
                  การคืนกุญแจ: หากคืนหลังเวลา 18.00 น. สามารถส่งคืนได้ที่ Mill Manager อาคาร aA2
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-8 col-12">
              <Card className="card-primary">
                <FullCalendar
                  nowIndicator={true}
                  plugins={[
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin,
                    listPlugin
                  ]}
                  slotLabelFormat={{
                    hour: '2-digit',
                    minute: '2-digit',
                    // omitZeroMinute: true,
                    // meridiem: 'short',
                    hour12: false
                  }}
                  eventTimeFormat={{
                    // like '14:30:00'
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: false,
                    hour12: false
                  }}
                  initialView="dayGridMonth"
                  weekends={true}
                  ref={calendarRef}
                  headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
                  }}
                  dateClick={handleDateClick}
                  height={600}
                  events={events.filter((e) =>
                    cars.find((ee) => ee.id === e.cid && ee.visible == true)
                  )}
                />
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
